"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var uniqueId_1 = __importDefault(require("../../../util/uniqueId"));
var react_1 = require("react");
function Smile() {
    var path1 = react_1.useMemo(function () { return uniqueId_1.default('react-path-'); }, []);
    var mask1 = react_1.useMemo(function () { return uniqueId_1.default('react-mask-'); }, []);
    return (jsx_runtime_1.jsxs("g", __assign({ transform: 'translate(2.000000, 52.000000)' }, { children: [jsx_runtime_1.jsx("defs", { children: jsx_runtime_1.jsx("path", { id: path1, d: 'M35.117844,15.1280772 C36.1757121,24.6198025 44.2259873,32 54,32 C63.8042055,32 71.8740075,24.574136 72.8917593,15.0400546 C72.9736685,14.272746 72.1167429,13 71.042767,13 C56.1487536,13 44.7379213,13 37.0868244,13 C36.0066168,13 35.0120058,14.1784435 35.117844,15.1280772 Z' }, void 0) }, void 0),
            jsx_runtime_1.jsx("mask", __assign({ id: mask1, fill: 'white' }, { children: jsx_runtime_1.jsx("use", { xlinkHref: '#' + path1 }, void 0) }), void 0),
            jsx_runtime_1.jsx("use", { fillOpacity: '0.699999988', fill: '#000000', fillRule: 'evenodd', xlinkHref: '#' + path1 }, void 0),
            jsx_runtime_1.jsx("rect", { fill: '#FFFFFF', fillRule: 'evenodd', mask: "url(#" + mask1 + ")", x: '39', y: '2', width: '31', height: '16', rx: '5' }, void 0),
            jsx_runtime_1.jsx("g", __assign({ strokeWidth: '1', fillRule: 'evenodd', mask: "url(#" + mask1 + ")", fill: '#FF4F6D' }, { children: jsx_runtime_1.jsxs("g", __assign({ transform: 'translate(38.000000, 24.000000)' }, { children: [jsx_runtime_1.jsx("circle", { cx: '11', cy: '11', r: '11' }, void 0),
                        jsx_runtime_1.jsx("circle", { cx: '21', cy: '11', r: '11' }, void 0)] }), void 0) }), void 0)] }), void 0));
}
exports.default = Smile;
